import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Login } from '../../services/login.service';
import { useTranslation } from 'react-i18next';
import Input from '../../components/forms/input.component';
import Button from '../../components/forms/button.component';
import SelectLanguage from '../../components/layout/select-language.component';
import Icon from '../../components/forms/icon.component';

interface AuthProps {
  typeAuth: string;
  setTypeAuth: (value: 'login' | 'recover') => void;
}

function RecoverPasswordForm({ setTypeAuth }: AuthProps) {
  const { t } = useTranslation();
  const defaultValues = {
    username: ''
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid, isSubmitting }
  } = useForm({
    mode: 'onChange',
    defaultValues
  });
  const [alert, setAlert] = useState<{ type: string; message: string } | null>(null);

  const handleAlertClose = () => {
    setAlert(null);
    setTypeAuth('login');
  };

  const handleRecoverPassword = () => {
    setTypeAuth('login');
  };

  const submit = async (data: any) => {
    try {
      await Login.recoverPassword(data);
      setAlert({
        type: 'success',
        message: t('auth-Login.recover-success')
      });
      reset(defaultValues);
    } catch (errorCode: any) {
      console.log('Error: ', errorCode);
      setAlert({ type: 'error', message: errorCode.error || errorCode });
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(submit)}>
        {alert && (
          <div
            className={`alert d-flex align-items-center p-2 ${alert.type === 'error' ? 'alert-danger' : 'alert-primary'}`}
          >
            <Icon
              icon={`${alert.type === 'error' ? 'ki-shield-cross' : 'ki-shield-tick'}`}
              size="fs-2hx"
              type="white"
              className="me-4"
            />
            <div className="d-flex flex-column">
              <h4 className="mb-1 text-white">
                {alert.type === 'error' ? t('general.atention') : t('general.succes')}
              </h4>
              <span>{alert.message}</span>
            </div>
            <a
              className="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
              onClick={handleAlertClose}
            >
              <Icon icon="ki-cross" size="fs-1" type="white" />
            </a>
          </div>
        )}

        <div className="fv-row mb-12 inputb">
          <Input
            typeBg={'text-white'}
            requiredIndicator="required"
            label={t('forms.inputs.title-input-username')}
            uniqueTheme
            placeholder={t('forms.inputs.placeholder-input-username')}
            errors={errors.username}
            {...register('username', {
              required: true,
              setValueAs: (value) => value.trim()
            })}
          />
        </div>
        <div className="text-center">
          <Button
            type="submit"
            className="btn btn-lg btn-primary w-100 mb-3"
            disabled={!isValid}
            isLoading={isSubmitting}
            onClick={handleSubmit(submit)}
          >
            {t('auth-Login.recover-btn-submit')}
          </Button>
        </div>
      </form>
      <div className="d-flex flex-stack inputb">
        <div className="me-20">
          <button
            className="btn text-gray-500 text-hover-primary cursor-pointer"
            onClick={handleRecoverPassword}
            type="button"
          >
            {t('auth-Login.title')}
          </button>
        </div>
        <SelectLanguage />
      </div>
    </>
  );
}

export default RecoverPasswordForm;
